// Estação ?print=TOKEN do PDV público: o que ela imprime.
// Pedido do link/catálogo: como sempre. Venda de PDV: só quando ninguém mais
// vai imprimir — o servidor grava em orders.print_via, na criação, quem imprime
// ("aparelho", "app" ou "estacao"; ver decidirImpressaoPdv). Venda antiga ou de
// aba antiga (sem print_via) a estação continua pulando, como fazia antes.
export function estacaoImprime(order: { source?: string | null; printVia?: string | null }): boolean {
  // Histórico de outro cardápio (T-0033, 01/11/2026): não imprime.
  if (order.source === "importado") return false;
  if (order.source !== "pdv") return true;
  return order.printVia === "estacao";
}
